import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {useTranslation} from '@/translations/i18n'
import {ErrorBox} from '../error-box/ErrorBox'
import {AlertCircleIcon, ArrowLeftIcon} from '@/components/ui/icon/Icon'
import {FC} from 'react'

interface NoPermissionBoxProps {
    /** Overrides the generic "no permission" copy, e.g. with the resource-specific message resolved from a BE 403. */
    title?: string
}

export const NoPermissionBox: FC<NoPermissionBoxProps> = ({title}) => {
    const {t} = useTranslation()

    return (
        <ErrorBox
            title={title ?? t('errors:no_permission_page')}
            icon={<AlertCircleIcon />}
            cta={
                <ButtonLink size="xl" variant="secondary" to="/">
                    <ArrowLeftIcon />
                    {t('commons:back_to_homepage')}
                </ButtonLink>
            }
        />
    )
}
